(() => {
  const moveInquiryButtons = () => {
    document.querySelectorAll('.product__info-container').forEach((info) => {
      const cartButton = info.querySelector('product-form button[name="add"]');
      const inquiry = info.querySelector('.cfp-prod-button');
      if (!cartButton || !inquiry) return;
      const productForm = cartButton.closest('product-form');
      const anchor = productForm.parentElement;
      if (anchor.nextElementSibling !== inquiry) anchor.after(inquiry);
      inquiry.style.width = '100%';
      const button = inquiry.querySelector('.call-for-price-btn');
      if (button) {
        button.style.width = '100%';
        button.style.minHeight = '52px';
      }
    });
  };
  let pending = false;
  const schedule = () => {
    if (pending) return;
    pending = true;
    requestAnimationFrame(() => {
      pending = false;
      moveInquiryButtons();
    });
  };
  new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', schedule);
  moveInquiryButtons();
})();
